import { MC_LIST_ID } from "theme/config/constants";
import { put } from "core-web/libs/GrebbCommerceAPI/util";

export default async ({ email, tags }) => {
    const data = {
        email,
        accepts_email: true,
        tags,
    };

    return await put(`/frontend/newsletter/lists/${MC_LIST_ID}/subscribe`, data);
};
